import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IDefaultSettingResponse,
  IDefaultSettingPayload,
} from "models/setting/default";
import { httpStatus } from "configs/httpStatus";
import { setDefaultSetting } from "services/setting";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./defaultSettingActions";

function* setDefaultSettingSaga({
  payload,
}: {
  payload: IDefaultSettingPayload;
}) {
  try {
    const response: IDefaultSettingResponse = yield call(
      setDefaultSetting,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDefaultSettingWatcher() {
  yield takeLatest(ActionType.DEFAULT_SETTING as any, setDefaultSettingSaga);
}

export default [fork(onDefaultSettingWatcher)];
